<template>
    <el-dialog title="藏品移库验收" width="60%" :close-on-click-modal="false" append-to-body :visible.sync="visible">
        <div class="m_b1">移库藏品：</div>
        <el-table
                :data="dataList"
                v-loading="loading"
                size="small" max-height="420"
                class="table" border>
            <el-table-column prop="mingcheng" label="藏品名称" show-overflow-tooltip></el-table-column>
            <el-table-column prop="collectionNumber" label="藏品编号" show-overflow-tooltip></el-table-column>
            <el-table-column prop="moveLibraryNumber" label="移库编号" show-overflow-tooltip></el-table-column>
            <el-table-column prop="resourceNumber" label="资源数量" show-overflow-tooltip></el-table-column>
        </el-table>
        <pagination :total="total" :page.sync="searchForm.current" :limit.sync="searchForm.size"
                    @pagination="getList"/>
        <div slot="footer" class="text_center">
            <el-button size="small" type="primary" :disabled="loading" @click="acceptance('验收成功')" v-noMoreClick>验收成功</el-button>
            <el-button size="small" type="primary" :disabled="loading" plain @click="acceptanceFail()" v-noMoreClick>验收失败</el-button>
        </div>

    </el-dialog>
</template>

<script>
    export default {
        name: "storage",
        data() {
            return {
                visible: false,
                loading: false,
                dataList: [],
                searchForm: {
                    basicDataId: '',
                    dataIds: '',
                    current: 1,
                    size: 20,
                },
                total: 0,
            }
        },
        methods: {
            init(basicDataId, ids) {
                this.searchForm.basicDataId = basicDataId
                this.searchForm.dataIds = ids
                this.dataList = []
                this.visible = true
                this.getList()
            },
            // 获取列表数据
            getList() {
                this.loading = true
                this.$axios(this.api.metadata.moveLibraryAcceptance, this.searchForm, 'post').then(data => {
                    if (data.status) {
                        this.dataList = data.data.records
                        this.total = parseInt(data.data.total)
                    } else {
                        this.$message.error('查询失败')
                    }
                    this.loading = false
                })
            },
            // 验收  0成功，1失败
            acceptance(status, cause) {
                this.loading = true
                this.$axios(this.api.metadata.acceptance, {
                    acceptanceStatus: status,
                    cause: cause || '',
                    dataIds: this.searchForm.dataIds,
                }, 'post').then(data => {
                    if (data.status) {
                        this.$message.success('操作成功')
                        this.$emit('refreshData')
                        this.visible = false
                    } else {
                        this.$message.error('操作失败')
                    }
                    this.loading = false
                })
            },
            // 验收失败
            acceptanceFail() {
                this.$prompt('验收失败原因：', '提示', {
                    confirmButtonText: '保存',
                    cancelButtonText: '取消',
                    inputPlaceholder: '请输入验收失败原因（限200字）',
                    inputValidator: value => {
                        if((value && value.trim() == '') || !value) {
                            return '请输入验收失败原因！'
                        }
                        if(value.length > 200) {
                            return '验收失败原因限200字'
                        }
                    },
                    inputErrorMessage: '请输入验收失败原因！'
                }).then(({ value }) => {
                    this.acceptance('验收失败', value)
                })
            }
        }
    }
</script>

<style scoped>

</style>
